module.exports = __webpack_public_path__ + "img/buy-now.970048b5.png";